import { render, staticRenderFns } from "./FavoriteButton.vue?vue&type=template&id=febfadc8&scoped=true&"
import script from "./FavoriteButton.vue?vue&type=script&lang=js&"
export * from "./FavoriteButton.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteButton.vue?vue&type=style&index=0&id=febfadc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febfadc8",
  null
  
)

export default component.exports